import { HttpClient } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router } from '@angular/router';
import { CoachBotDataAccessAuthModule } from '@coach-bot/data-access/auth';
import { ENVIRONMENT } from '@coach-bot/data-access/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MenusModule } from '@progress/kendo-angular-menu';
import { NotificationService } from '@progress/kendo-angular-notification';
import * as Sentry from '@sentry/angular';
import { CoreModule } from 'app/core/core.module';
import { FeedbackModule } from 'app/shared/components/feedback/feedback.module';
import { environment } from '../environments/environment.develop';
import { appInitializeFactory } from './app-initialize.factory';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

@NgModule({
  bootstrap: [AppComponent],
  declarations: [AppComponent],
  imports: [
    CoachBotDataAccessAuthModule,
    AppRoutingModule,
    CoreModule,
    FeedbackModule,
    MatSnackBarModule,
    MatDialogModule,
    MatMenuModule,
    BrowserAnimationsModule,
    StoreModule.forRoot({}, {}),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production }),
    MenusModule,
    TranslateModule.forRoot(),
  ],
  providers: [
    NotificationService,
    {
      provide: ENVIRONMENT,
      useValue: environment,
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializeFactory,
      deps: [Sentry.TraceService, TranslateService, HttpClient],
      multi: true,
    },
  ],
})
export class AppModule {
}
